import { render, staticRenderFns } from "./ArticleSlide.vue?vue&type=template&id=2642cfa7&scoped=true&"
import script from "./ArticleSlide.vue?vue&type=script&lang=js&"
export * from "./ArticleSlide.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSlide.vue?vue&type=style&index=0&id=2642cfa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642cfa7",
  null
  
)

export default component.exports